import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blog/blog-reader.tsx");
